module.exports = __webpack_public_path__ + "static/media/magento_img-2.588d9086.png";